import React, { useEffect, useRef, useState } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import { useSelector, useDispatch, connect } from "react-redux"
import axios from "axios"
import AddIcon from "@mui/icons-material/Add"
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth"
import PlatformReviewDashboard from "newcomponents/platform-review-graph"
import SurveyDashboard from "newcomponents/survey-chart"
import CustomerTrendsDashboard from "newcomponents/customer-trends"
import CategoryScoreDashboard from "newcomponents/category-score"
import config from "config/config"
import MonthlyEarnings from "./montly-earnings"
import MonthlyEarnings2 from "./montly-earnings2"
import MonthlyEarnings3 from "./monthly-earnings3"
import EmailSent from "./email-sent"
import Miniwidgets from "pages/FacebookDashboard/MiniWidgets"
import { format } from "date-fns"
// ... other imports

import SnackbarComponent from "components/SnackBar"
import { setBreadcrumbItems } from "../../store/actions"
import PrimaryButton from "newcomponents/primary-button"
import DoctorAnalysis from "pages/DoctorAnalysis"

const Dashboard = props => {
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const userData = useSelector(state => state.Login.userData)
  const { organizations, isConsolidatedView } = useSelector(
    state => state.organizationReducer,
  )
  const [loading, setLoading] = useState(false)
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState("")
  const [customers, setCustomers] = useState(null)
  const [doctors, setDoctors] = useState([])
  const [selectedDoctorId, setSelectedDoctorId] = useState("") // ← NEW
  const [err, setErr] = useState(null)
  const [success, setSuccess] = useState(null)
  const [reports, setReports] = useState([])
  const [viewMode, setViewMode] = useState("Month")
  console.log(reports, "reports in dashboard")
  document.title = "Dashboard | AeraVue"
  const mode = useSelector(state => state.Layout.layoutMode)

  const loadDataForOrg = async () => {
    setLoading(true)

    try {
      // 1) Fetch customers
      const customersScoreResp = await axios.get(
        `${config.backendUrl}/customers/${activeOrganization.id}/${viewMode}?startDate=${fromDate}&endDate=${toDate}`,
        {
          headers: { Authorization: `Bearer ${userData.token}` },
        },
      )

      const sentimentResp = await axios.get(
        `${config.backendUrl}/organization/sentimentAnalysis?orgId=${activeOrganization.id}&viewMode=${viewMode}&startDate=${fromDate}&endDate=${toDate}`,
        {
          headers: { Authorization: `Bearer ${userData.token}` },
        },
      )

      const socialMediaEngagementsResponse = await axios.get(
        `${config.backendUrl}/organization/getOrganizationSocialMediaEngagements?orgId=${activeOrganization.id}&viewMode=${viewMode}&startDate=${fromDate}&endDate=${toDate}`,
        {
          headers: { Authorization: `Bearer ${userData.token}` },
        },
      )

      // All done—set the final array of reports
      setReports([
        {
          title: "Customers Count",
          iconClass: "account-group",
          total: customersScoreResp.data.count,
          average: customersScoreResp.data.percentage, // Use the signed percentage difference
          badgecolor:
            parseFloat(customersScoreResp.data.percentage.replace("%", "")) >= 0
              ? "success"
              : "danger", // Set badge color based on growth or decline
        },
        {
          title: "Sentiment",
          iconClass: "emoticon-outline",
          total: sentimentResp.data.currentRange.score || "0",
          average: sentimentResp.data.sentimentPercentageDifference,
          badgecolor:
            parseFloat(sentimentResp.data.sentimentPercentageDifference) >= 0
              ? "success"
              : "danger",
        },
        {
          title: "Social (Followers)",
          iconClass: "nature-people",
          total: socialMediaEngagementsResponse.data.followers.current,
          average:
            socialMediaEngagementsResponse.data.followers.percentageDifference,
          badgecolor:
            parseFloat(
              socialMediaEngagementsResponse.data.followers
                .percentageDifference,
            ) >= 0
              ? "success"
              : "danger",
        },
        {
          title: "Social (Likes)",
          iconClass: "nature-people",
          total: socialMediaEngagementsResponse.data.likes.current,
          average:
            socialMediaEngagementsResponse.data.likes.percentageDifference,
          badgecolor:
            parseFloat(
              socialMediaEngagementsResponse.data.likes.percentageDifference,
            ) >= 0
              ? "success"
              : "danger",
        },
      ])

      setLoading(false)
    } catch (mainErr) {
      console.error(mainErr)
      setErr("Error fetching data for Dashboard.")
    } finally {
      setLoading(false)
    }
  }

  const formatDateDisplay = dateStr => {
    if (!dateStr) return "dd/mm/yyyy"
    const date = new Date(dateStr)
    const day = String(date.getDate()).padStart(2, "0")
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
  }

  const fromDateRef = useRef(null)
  const toDateRef = useRef(null)

  useEffect(() => {
    // Set breadcrumb items for the new organization
    const breadcrumbItems = [
      {
        title: `${activeOrganization?.name}`,
        link: "#",
      },
      { title: "Dashboard", link: "#" },
    ]
    props.setBreadcrumbItems(
      `${activeOrganization?.name} (${activeOrganization?.type})`,
      breadcrumbItems,
    )

    // Load all data for the active organization
    if (!selectedDoctorId) {
      // only load generic dashboard data in "All doctors" mode
      loadDataForOrg(activeOrganization)
    }
  }, [activeOrganization, viewMode, selectedDoctorId])

  const fetchDoctors = async () => {
    setLoading(true)
    try {
      const response = await axios.get(
        `${config.backendUrl}/doctors?orgId=${activeOrganization.id}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      setDoctors(response.data.doctors || [])
    } catch (err) {
      setErr("Error fetching doctors.")
      console.log("Error fetching doctors", err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (activeOrganization && activeOrganization.id) {
      fetchDoctors()
    }
  }, [activeOrganization?.id])

  const selectedDoctor = doctors.find(
    d => String(d.id) === String(selectedDoctorId),
  )

  return (
    <React.Fragment>
      <SnackbarComponent
        err={err}
        success={success}
        setErr={setErr}
        setSuccess={setSuccess}
      />
      <div
        className="br"
        style={{
          backgroundColor: mode === "dark" ? "#252f40" : "#fff",
          marginTop: "0px",
          padding: "20px 20px",
          fontFamily: "Inter",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          color: mode === "dark" ? "#fff" : "#050409",
          fontWeight: "600",
          fontSize: "23px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        {/* Left side: org name */}
        <h1>
          {isConsolidatedView ? "Consolidated View" : activeOrganization?.name}
        </h1>

        {/* Right side: doctor dropdown + date inputs + button */}
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          {/* Doctor Dropdown (to the LEFT of date range) */}
          <div
            style={{
              minWidth: "220px",
              backgroundColor: mode === "dark" ? "#1a2332" : "#F9FAFB",
              border:
                mode === "dark" ? "1px solid #374151" : "1px solid #E5E7EB",
              borderRadius: "8px",
              padding: "6px 10px",
            }}
          >
            <select
              value={selectedDoctorId}
              onChange={e => setSelectedDoctorId(e.target.value)}
              style={{
                width: "100%",
                background: "transparent",
                border: "none",
                outline: "none",
                color: mode === "dark" ? "#fff" : "#374151",
                fontSize: "14px",
              }}
            >
              <option value="">Dashboard</option>
              {doctors.map(doc => (
                <option key={doc.id} value={doc.id}>
                  {`${doc.firstName || ""} ${doc.lastName || ""}`.trim() ||
                    `Doctor #${doc.id}`}
                </option>
              ))}
            </select>
          </div>

          {/* Date range */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: mode === "dark" ? "#1a2332" : "#F9FAFB",
              border:
                mode === "dark" ? "1px solid #374151" : "1px solid #E5E7EB",
              borderRadius: "8px",
              padding: "8px 12px",
              minWidth: "280px",
              gap: "8px",
            }}
          >
            {/* From Date */}
            <div
              style={{ position: "relative", flex: 1, cursor: "pointer" }}
              onClick={() => fromDateRef.current?.showPicker()}
            >
              <input
                ref={fromDateRef}
                type="date"
                value={fromDate}
                onChange={e => setFromDate(e.target.value)}
                style={{
                  position: "absolute",
                  inset: 0,
                  opacity: 0,
                  pointerEvents: "none", // input hidden but still usable
                }}
              />
              <span
                style={{
                  color: fromDate
                    ? mode === "dark"
                      ? "#fff"
                      : "#374151"
                    : "#9CA3AF",
                  fontSize: "14px",
                }}
              >
                {fromDate ? formatDateDisplay(fromDate) : "dd/mm/yyyy"}
              </span>
            </div>

            <span style={{ color: "#9CA3AF" }}>-</span>

            {/* To Date */}
            <div
              style={{ position: "relative", flex: 1, cursor: "pointer" }}
              onClick={() => toDateRef.current?.showPicker()}
            >
              <input
                ref={toDateRef}
                type="date"
                value={toDate}
                onChange={e => setToDate(e.target.value)}
                style={{
                  position: "absolute",
                  inset: 0,
                  opacity: 0,
                  pointerEvents: "none",
                }}
              />
              <span
                style={{
                  color: toDate
                    ? mode === "dark"
                      ? "#fff"
                      : "#374151"
                    : "#9CA3AF",
                  fontSize: "14px",
                }}
              >
                {toDate ? formatDateDisplay(toDate) : "dd/mm/yyyy"}
              </span>
            </div>

            <CalendarMonthIcon
              size={18}
              style={{
                color: mode === "dark" ? "#9CA3AF" : "#6B7280",
                flexShrink: 0,
              }}
            />
          </div>

          {/* Create New Button */}
          <PrimaryButton
            style={{
              padding: "15px 35px",
              fontSize: "20px",
              fontWeight: "500",
              borderRadius: "8px",
            }}
            icon={<AddIcon />}
            onClick={() => {
              window.location.href = `/dashboard/create-campaign`
            }}
          >
            Create New
          </PrimaryButton>
        </div>
      </div>

      {/* CONTENT AREA */}
      {selectedDoctorId && selectedDoctor ? (
        // ================== DOCTOR PAGE VIEW (you will customize this) ==================
        <DoctorAnalysis id={selectedDoctorId} />
      ) : (
        // ================== ORIGINAL DASHBOARD VIEW ==================
        <>
          <Row style={{ marginBottom: "20px" }}>
            <Col xl="6">
              <PlatformReviewDashboard
                fromDate={fromDate}
                toDate={toDate}
                title="Platform Reviews Count"
              />
            </Col>
            <Col xl="6">
              <SurveyDashboard
                fromDate={fromDate}
                toDate={toDate}
                title="Survey Statistics"
                legend={["Distributed", "Opened", "Responded"]}
              />
            </Col>
          </Row>
          <Row>
            <Col xl="12" style={{ marginBottom: "20px" }}>
              <CategoryScoreDashboard
                fromDate={fromDate}
                toDate={toDate}
                viewMode={"Custom"}
              />
            </Col>
          </Row>

          <Row>
            <Col xl="12">
              <EmailSent
                viewMode={viewMode}
                fromDate={fromDate}
                toDate={toDate}
              />
            </Col>
          </Row>
        </>
      )}
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(Dashboard)
